import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

/**
 * Language switcher component for toggling between English and Japanese
 */
const LanguageSwitcher = ({ className = '' }) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const toggleLanguage = () => {
    const newLang = currentLang === 'jp' ? 'en' : 'jp';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      className={`
        flex items-center gap-2 px-3 py-2
        bg-gray-100 hover:bg-gray-200
        dark:bg-gray-800 dark:hover:bg-gray-700
        rounded-md transition-colors duration-200
        text-sm font-medium
        ${className}
      `}
      title={`Switch to ${currentLang === 'jp' ? 'English' : 'Japanese'}`}
    >
      <Globe className="w-4 h-4" />
      <span>{t('lang.switch')}</span>
    </button>
  );
};

export default LanguageSwitcher;